module.exports = __webpack_public_path__ + "static/media/stack_img.1964a35c.png";